import React from "react";
import MUIDataTable from "mui-datatables";
import {
  createMuiTheme,
  MuiThemeProvider,
} from "@material-ui/core/styles";

import axios from 'axios';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Fab from '@material-ui/core/Fab';
import RefreshIcon from '@material-ui/icons/Refresh';
import EditIcon from '@material-ui/icons/Edit';
import { Container, Row, Col } from "shards-react";
import CircularProgress from '@material-ui/core/CircularProgress';
import  api from '../components/common/api';

class Crons extends React.Component {

   constructor() {
      super();

      this.state = {
        data: '',
        isLoaded: false,
        dialog:{id:'', open:''}
      }
    }

    async componentDidMount() {
      await this.getCrons();
    }
   
    getCrons(){
     const token = localStorage.getItem('userToken')

     return axios
              .get(api.crons().index(),{ headers: {"Authorization" : `Bearer ${token}`} })
              .then(res => {
                this.setState({isLoaded: true, data: res.data})
              })
              .catch(err =>{
                this.setState({isLoaded: true, data: [] })
              })
    }
   
    runCron(cron){
        const token = localStorage.getItem('userToken')
        var formData = new FormData();
        formData.set('cron', cron)
        
        axios.post(api.crons().run(),
            formData,
            {headers: {'Content-Type': 'multipart/form-data',"Authorization" : `Bearer ${token}`}}
            )
             .then(res => {
                   this.setState({isLoaded: true})
                 })
                 .catch(err =>{
                   this.setState({isLoaded: true})
                 })
       }
   

    getMuiTheme = () =>
      createMuiTheme({
        overrides: {
          MuiTableCell: {
           root: {
             padding: '0px 8px 0px 8px',
             fontSize: '0.73rem'
            }
          }
        }
    });      



    render(){
        const components = {
            ExpandButton: function(props) {
                if (props.dataIndex === 3 || props.dataIndex === 4) return <div style={{ width: '24px' }} />;
                return <EditIcon {...props} />;
            },
        };        
       const columns = [
       {
        name: "id",
        label: "Id",
        options: {
         filter: false,
         display: true,
         sort: true,
        }
       },
       {
        name: "cron",
        label: "Cron",
        options: {
         filter: false,
         display: true,
         sort: true,
        }
       },
       {
        name: "started_at",
        label: "Start",
        options: {
         filter: false,
         display: true,
         sort: true,
        }
       },
       {
        name: "ended_at",
        label: "End",
        options: {
         filter: false,
         display: true,
         sort: true,
        }
       },
       {
        name: "result",
        label: "Result",
        options: {
         filter: false,
         display: false,
         viewColumns: false,
         sort: true,
        }
       },{
        name: "Acciones",
        label: "",
        options: {
            filter: false,
            setCellHeaderProps: () => ({ align: 'center' }),
            customBodyRender: (value, tableMeta, updateValue) => {
              const cron = tableMeta.rowData[1]
              //const rowId = 1
              return (
                <div className="row" style={{display: 'block'}}>
                  <Fab color="primary" aria-label="view"  variant="extended" style={{boxShadow: 'none', backgroundColor: "green" }} fontSize="small" className='MuiButtonBase-root MuiFab-sizeSmall mr-2' onClick={() => {this.runCron(cron)}} >
                    <RefreshIcon fontSize="small" /> 
                  </Fab>
                </div>
                  )}
            }
     }          
      ];


    const options = {
      print:false,
      responsive: 'standard',
      selectableRowsOnClick: false,
      expandableRows: true,
      expandableRowsHeader: false,
      expandableRowsOnClick: true,    
      rowsExpanded: [],
      renderExpandableRow: (rowData, rowMeta) => {
        console.log('rowData', rowData)
        const data = rowData[4]
        const colSpan = rowData.length + 1;
        return (
            <TableRow>
                <TableCell colSpan={colSpan}><p style={{padding: 10, maxWidth: 800, overflow: 'auto', margin: '0 auto'}}>Resultado: {data}</p></TableCell>
            </TableRow>            
        );
      },
      onRowExpansionChange: (curExpanded, allExpanded, rowsExpanded) =>
        console.log(curExpanded, allExpanded, rowsExpanded),        
      download: false,
      rowsPerPage: 10,
      textLabels: {
            toolbar: {
              search: "Buscar",
              viewColumns: "Ver columnas",
              filterTable: "Filtros",   
              downloadCsv: "Exportar XLS",
            },
            body: {
                noMatch: this.state.isLoaded ?
                    'No hay resultados' :
                    <CircularProgress />,
            },
            selectedRows: {
              text: "fila(s) seleccionadas"
            },
            viewColumns: {
              title: "Ver columnas",
            },
            pagination: {
              next: "Siguiente",
              previous: "Anteior",
              rowsPerPage: "Cantidad por página:",
              displayRows: "de",      
            },
            filter: {
              all: "Todos",
              title: "Filtros",
              reset: "Limpiar"
            }
        }
    };

     return(
        <Container fluid className="main-content-container px-4">
            <Row>
              <Col className="p-2">
                {this.state.isLoaded && <div>
                    <MuiThemeProvider theme={this.getMuiTheme()}>
                    <MUIDataTable
                        title="Crones"
                        data={Object.values(this.state.data)}
                        columns={columns}
                        options={options}
                        components={components}
                    />
                    </MuiThemeProvider>
                </div>
                }   
              </Col>
            </Row>
           </Container>
      );
    }

}

export default Crons;   